import React from 'react';
import { Dialog, DialogActions, DialogContent, Button } from '@mui/material';
import { DocumentOverview } from '../../Document/DocumentOverview';
import { LegalRequirementUploadFiles } from './LegalRequirementUploadFiles';
import { LegalRequirementRequestFiles } from './LegalRequirementRequestFiles';
import { IDocument } from '../../../../Interfaces/IDocument';
import { ILegalRequirement } from '../../../../Interfaces/ILegalRequirement';
import { ILegalTransactionFullObject } from '../../../../Interfaces/ILegalTransaction';
import { IConfig } from '../../../../Interfaces/IConfig';

interface IProps {
  configObject: IConfig;
  legalTransaction: ILegalTransactionFullObject;
  currentReq: ILegalRequirement | null;
  documentArrayClient: IDocument[];
  setDocumentArrayClient: (docs: IDocument[]) => void;
  documentArrayEmployees: IDocument[];
  isOpenClient: boolean;
  setIsOpenClient: (v: boolean) => void;
  isOpenEmployees: boolean;
  setIsOpenEmployees: (v: boolean) => void;
  isOpenUpload: boolean;
  setIsOpenUpload: (v: boolean) => void;
  handleCloseClient: () => void;
}

export const LegalRequirementDocumentDialogs: React.FC<IProps> = ({
                                                                    configObject,
                                                                    legalTransaction,
                                                                    currentReq,
                                                                    documentArrayClient,
                                                                    setDocumentArrayClient,
                                                                    documentArrayEmployees,
                                                                    isOpenClient,
                                                                    setIsOpenClient,
                                                                    isOpenEmployees,
                                                                    setIsOpenEmployees,
                                                                    isOpenUpload,
                                                                    setIsOpenUpload,
                                                                    handleCloseClient,
                                                                  }) => {
  return (
    <>
      {/* Upload Dialog */}
      <LegalRequirementUploadFiles
        idLegalTransaction={legalTransaction.idLegalTransaction}
        documentArrayClient={documentArrayClient}
        setDocumentArrayClient={setDocumentArrayClient}
        isOpen={isOpenUpload}
        setIsOpen={setIsOpenUpload}
      />

      {/* Client Dialog */}
      <Dialog
        open={isOpenClient}
        onClose={handleCloseClient}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent>
          {currentReq && (
            <DocumentOverview
              configObject={configObject}
              legalTransactionObject={legalTransaction}
              idLegalRequirement={currentReq.idLegalRequirement}
              documentArray={documentArrayClient}
              setDocumentArray={setDocumentArrayClient}
              allowRemove={false}
              allowUpload
              title="Ihre Daten"
              showReadPermission
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleCloseClient}>
            Okay
          </Button>
        </DialogActions>
      </Dialog>

      {/* Employees Dialog */}
      <Dialog
        open={isOpenEmployees}
        onClose={() => setIsOpenEmployees(false)}
        maxWidth="lg"
        fullWidth
      >
        <LegalRequirementRequestFiles
          configObject={configObject}
          legalTransaction={legalTransaction}
          documentArray={documentArrayEmployees}
          setIsOpen={setIsOpenEmployees}
        />
      </Dialog>
    </>
  );
};
